import { z } from 'zod';
// ---------------------------------------------------------------------------
// Ingredient measurement units
// ---------------------------------------------------------------------------
export const INGREDIENT_UNITS = [
    'g',
    'kg',
    'ml',
    'cl',
    'l',
    'tsp',
    'tbsp',
    'cup',
    'oz',
    'lb',
    'fl_oz',
    'piece',
    'pinch',
    'bunch',
    'slice',
    'clove',
    'other',
];
export const ingredientUnitSchema = z.enum(INGREDIENT_UNITS);
/**
 * The handful a shopping list actually uses.
 *
 * The full catalogue exists for a recipe, where a pinch and a clove are how a
 * cook writes. A basket is weighed or counted: offering seventeen units to
 * qualify « 2 » of something turns a one-tap field into a menu to read.
 */
export const COMMON_INGREDIENT_UNITS = ['g', 'kg', 'ml', 'cl', 'l', 'piece'];
/**
 * What a quantity means when nothing else is said.
 *
 * A shopping line typed by hand is a count far more often than a weight — two
 * baguettes, six eggs — and an empty unit field left « 2 » standing for
 * nothing. It is also the one unit the list never writes out: « 8 » under a
 * name already says eight of them.
 */
export const DEFAULT_INGREDIENT_UNIT = 'piece';
/**
 * Units that stand for no fixed amount, so nothing can be converted from them:
 * a pinch is a gesture and a clove is an object, not a measure.
 */
const UNCONVERTIBLE_UNITS = new Set(['other', 'piece', 'pinch', 'bunch', 'slice', 'clove']);
/** Whether equivalences can be computed for this unit at all. */
export function isConvertibleUnit(unit) {
    if (!unit)
        return false;
    return INGREDIENT_UNITS.includes(unit) && !UNCONVERTIBLE_UNITS.has(unit);
}
export const INGREDIENT_UNIT_LABELS = {
    g: { fr: 'g', en: 'g' },
    kg: { fr: 'kg', en: 'kg' },
    ml: { fr: 'ml', en: 'ml' },
    cl: { fr: 'cl', en: 'cl' },
    l: { fr: 'L', en: 'L' },
    tsp: { fr: 'c.\u00a0à\u00a0c.', en: 'tsp' },
    tbsp: { fr: 'c.\u00a0à\u00a0s.', en: 'tbsp' },
    cup: { fr: 'tasse', en: 'cup' },
    oz: { fr: 'oz', en: 'oz' },
    lb: { fr: 'lb', en: 'lb' },
    fl_oz: { fr: 'fl oz', en: 'fl oz' },
    piece: { fr: 'pièce', en: 'piece' },
    pinch: { fr: 'pincée', en: 'pinch' },
    bunch: { fr: 'botte', en: 'bunch' },
    slice: { fr: 'tranche', en: 'slice' },
    clove: { fr: 'gousse', en: 'clove' },
    other: { fr: 'autre', en: 'other' },
};
// ---------------------------------------------------------------------------
// Unit types (for conversion grouping)
// ---------------------------------------------------------------------------
export const UNIT_TYPES = ['weight', 'volume'];
export const unitTypeSchema = z.enum(UNIT_TYPES);
//# sourceMappingURL=units.js.map